import { Controller } from '@hotwired/stimulus'
import './opening_messages_component.css'

export default class extends Controller {}
